import React, { useContext, useEffect, useState } from 'react'
import OtpInput from 'react-otp-input';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BASE_URL_API } from '../../References/URLs';
import ActiveStoreContext from '../../store/ActiveStoreContext';
import AuthContext from '../../store/auth-context';
import styles from '../Users/AddNewClient.module.css'
import { Link } from 'react-router-dom'
import { FiPhone, FiUser, FiMail, FiMapPin, FiCalendar, FiUserPlus, FiX, FiUsers, FiLoader, FiInfo } from 'react-icons/fi';
import { Rainbow, HelpCircle } from 'lucide-react';
import { getAge } from '../../Helper/calculations';

// lucide-react (0.474.0) has no literal male/female glyphs — the ♂/♀ marks are
// the universally understood symbol for those two, Rainbow/HelpCircle cover the rest.
const GENDER_OPTIONS = [
    { value: 'Male', symbol: '♂' },
    { value: 'Female', symbol: '♀' },
    { value: 'LGBTQ', Icon: Rainbow },
    { value: 'Unknown', Icon: HelpCircle },
];

const TITLE_OPTIONS = [
    { value: 'Mr.', label: 'Mr.' },
    { value: 'Ms.', label: 'Ms.' },
    { value: 'Mrs.', label: 'Mrs.' },
    { value: 'Dr.', label: 'Dr.' },
    { value: 'Baby', label: 'Baby' },
    { value: 'Kumari', label: 'Kumari' },
];

// Mobile-only react-select skin — mirrors the plain .selectControl look
// (same palette/radius as the rest of this form) since react-select renders
// its own markup and can't be styled through the CSS module class directly.
// 48px is the exact box height .dateControl renders at on mobile with its
// normal, comfortable padding (see the mobile media query) — the Age select
// sits in the same row as Date of Birth, so it's pinned to match the input's
// natural height rather than the input being squeezed to fit the select.
const MOBILE_SELECT_HEIGHT = 48;

const mobileSelectStyles = {
    // Hard-capped: height + maxHeight + overflow:hidden means this box can
    // never be pushed taller than MOBILE_SELECT_HEIGHT by anything rendered
    // inside it (the clear "×", the chevron, react-select's own hidden
    // input) — it either fits inside 48px or gets clipped, it never grows.
    control: (base, state) => ({
        ...base,
        height: MOBILE_SELECT_HEIGHT,
        minHeight: MOBILE_SELECT_HEIGHT,
        maxHeight: MOBILE_SELECT_HEIGHT,
        overflow: 'hidden',
        boxSizing: 'border-box',
        borderRadius: 10,
        borderColor: state.isFocused ? '#2563eb' : 'rgba(148, 163, 184, 0.7)',
        backgroundColor: '#f8fafc',
        boxShadow: state.isFocused ? '0 0 0 1px rgba(37, 99, 235, 0.15)' : 'none',
        cursor: 'pointer',
        transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
        '&:hover': { borderColor: '#2563eb' },
    }),
    valueContainer: (base) => ({
        ...base,
        height: MOBILE_SELECT_HEIGHT - 2,
        maxHeight: MOBILE_SELECT_HEIGHT - 2,
        overflow: 'hidden',
        padding: '0 10px',
    }),
    input: (base) => ({ ...base, margin: 0, padding: 0, lineHeight: 1, color: '#0f172a', fontSize: 16 }),
    singleValue: (base) => ({ ...base, margin: 0, lineHeight: 1, color: '#0f172a', fontSize: 16 }),
    placeholder: (base) => ({ ...base, margin: 0, lineHeight: 1, color: '#94a3b8', fontSize: 16 }),
    indicatorsContainer: (base) => ({
        ...base,
        height: MOBILE_SELECT_HEIGHT - 2,
        maxHeight: MOBILE_SELECT_HEIGHT - 2,
        overflow: 'hidden',
    }),
    dropdownIndicator: (base) => ({ ...base, color: '#64748b', padding: 6 }),
    clearIndicator: (base) => ({ ...base, color: '#94a3b8', padding: 6 }),
    indicatorSeparator: () => ({ display: 'none' }),
    menuPortal: (base) => ({ ...base, zIndex: 3100 }),
    menu: (base) => ({
        ...base,
        borderRadius: 10,
        border: '1px solid rgba(148, 163, 184, 0.5)',
        boxShadow: '0 12px 30px rgba(15, 23, 42, 0.16)',
        overflow: 'hidden',
    }),
    menuList: (base) => ({ ...base, padding: 4, maxHeight: 220 }),
    option: (base, state) => ({
        ...base,
        fontSize: 14,
        borderRadius: 8,
        padding: '10px 12px',
        backgroundColor: state.isSelected ? '#2563eb' : state.isFocused ? 'rgba(37, 99, 235, 0.08)' : '#ffffff',
        color: state.isSelected ? '#ffffff' : '#1f2937',
        cursor: 'pointer',
    }),
};

const AddNewClient = props => {
    const authCtx = useContext(AuthContext);
    const { isOpen, closeModal, assignClient } = props

    const [isReadyToSubmit, setIsReadyToSubmit] = useState(false);
    const [creationStatus, setCreationStatus] = useState('NOT_UPDATING'); // UPDATING
    const [isAlreadyRegistered, setIsAlreadyRegistered] = useState(false)
    const [clientToAssign, setClientToAssign] = useState(null)
    const asCtx = useContext(ActiveStoreContext)
    const activeStore = (() => { try { return (asCtx?.activeStore && asCtx.activeStore.trim() !== "") ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();

    const [dob, setDob] = useState('')

    const [isMobileViewport, setIsMobileViewport] = useState(() => {
        if (typeof window === 'undefined') {
            return false;
        }
        return window.innerWidth <= 768;
    });

    useEffect(() => {
        const handleViewportResize = () => {
            setIsMobileViewport(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleViewportResize);
        return () => {
            window.removeEventListener('resize', handleViewportResize);
        };
    }, []);

    window.onclick = function (event) {
        if (event.target.id === "addNewClientForm") {
            closeModal();
        }

        if (event.target.id === "filtersPanelWrapperMUG") {
            document.getElementById("filtersPanelWrapperMUG").style.animation = "slideRightToLeft .1s forwards";
        }

    }

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            document.getElementById("filtersPanelWrapperMUG").style.animation = "slideRightToLeft .1s forwards";
            closeModal()
        }
    });

    const [phoneNumber, setPhoneNumber] = useState({
        otp: props.phone
    });
    const [fullName, setFullName] = useState('');
    const [middleName, setMiddleName] = useState('')
    const [gender, setGender] = useState('')
    const [address, setAddress] = useState('')
    const [dayAnniversary, setDayAnniversary] = useState('')
    const [monthAnniversary, setMonthAnniversary] = useState('')
    const [email, setEmail] = useState('')
    const [title, setTitle] = useState('')

    const phoneNumberHandler = (otp) => {
        setPhoneNumber({ otp });
    }

    const isReadyHandler = () => {
        if (phoneNumber?.otp?.length === 10) {
            if (fullName?.trim()?.length > 1) {
                if (gender !== '') {
                    setIsReadyToSubmit(true)
                } else {
                    setIsReadyToSubmit(false)
                }
            } else {
                setIsReadyToSubmit(false)
            }
        } else {
            setIsReadyToSubmit(false)
        }
    }

    useEffect(() => {
        isReadyHandler()
    }, [phoneNumber, fullName, gender])

    useEffect(() => {
        setPhoneNumber({ otp: props.phone })
    }, [props.phone])

    useEffect(() => {
        if (isOpen === false) {
            setPhoneNumber({ otp: '' })
            setIsAlreadyRegistered(false)
            setFullName('')
            setMiddleName('')
            setGender('')
            setAddress('')
            setEmail('')
            setTitle('')
        }
    }, [isOpen])


    const assignClientHandler = (k) => {
        assignClient(k)
        closeModal()
    }

    const addNewClientHandler = async () => {
        setCreationStatus('UPDATING')

        const clientFullName = fullName.trim()

        console.log(phoneNumber.otp, clientFullName, middleName, gender, address, dayAnniversary, monthAnniversary)

        const addNewClientResponse = await fetch(BASE_URL_API + "addNewClient",
            {
                method: 'POST',
                body: JSON.stringify({
                    token: authCtx.token,
                    storeIdentifier: activeStore?.storeIdentifier,
                    mobile: phoneNumber.otp,
                    firstName: clientFullName,
                    middleName: middleName,
                    lastName: '',
                    gender: gender,
                    address: address,
                    dob: dob,
                    salutation: title,
                    email: email
                })
            });

        if (!addNewClientResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const addNewClientRespo = await addNewClientResponse.json();
            if (addNewClientRespo.status === 'success') {
                if (assignClient !== undefined) {
                    assignClient(addNewClientRespo.response)
                    closeModal()
                }
                toast.success("Client successfully onboarded!")
            } else {
                if (addNewClientRespo.message === 'tokenExpired') {
                    authCtx.logout()
                } else if (addNewClientRespo.message === 'user already registered') {
                    toast(`Client is already registered!`)
                    if (assignClient !== undefined) {
                        setIsAlreadyRegistered(true)
                        setClientToAssign(addNewClientRespo?.response)
                        // assignClient(addNewClientRespo.response)
                        // closeModal()
                    }
                }
            }

            console.log(addNewClientRespo);
        }

        setCreationStatus('NOT_UPDATING')

    }


    const [ageYear, setAgeYear] = useState('')
    const [ageMonth, setAgeMonth] = useState('')

    const [years, setYears] = useState([]);

    useEffect(() => {
        const yearsArray = [];

        for (let year = 120; year >= 0; year--) {
            yearsArray.push(year);
        }

        setYears(yearsArray);
    }, []);

    const yearOptions = years?.map((item) => ({ value: String(item), label: String(item) })) || [];

    const getPastDate = (year, month) => {
        // Get the current date
        const currentDate = new Date();

        // Create a new Date object for the given year and month, setting the day to 1
        let date = new Date(currentDate.getFullYear() - year, month - 1, 1);

        // If the generated date is in the future, adjust the year backward by 1 year
        if (date > currentDate) {
            date.setFullYear(date.getFullYear() - 1);
        }

        // Format the date as "yyyy-MM-dd"
        const formattedDate = date.toISOString().split('T')[0];

        setDob(formattedDate);
    };

    useEffect(() => {
        if (!ageYear) {
            setAgeMonth('')
            return
        }
        const currentMonth = new Date().getMonth() + 1
        setAgeMonth(currentMonth)
        getPastDate(ageYear, currentMonth)
    }, [ageYear])


    const minimumRequirementsCopy = isAlreadyRegistered
        ? 'Client already exists in your store records.'
        : 'Phone number, full name, and gender are required.';

    if (isOpen) {
        return (
            <div className={styles.mainWrapper}>
                <div
                    className={styles.filtersPanelWrapper}
                    id="addNewClientForm"
                    style={{ animation: `openAddNewClientPanel 0.2s forwards` }}
                >
                    <div className={styles.drawer}>
                        <div className={styles.drawerHeader}>
                            <div className={styles.headerGroup}>
                                <span className={styles.headerBadge}>
                                    <FiUserPlus size={12} />
                                    Quickly Add New Client
                                </span>
                                <p className={styles.headerSubtitle}>
                                    Capture the essentials and keep moving.
                                </p>
                            </div>
                            <button
                                type="button"
                                className={styles.closeButton}
                                onClick={closeModal}
                                aria-label="Close add client dialog"
                            >
                                <FiX size={16} />
                            </button>
                        </div>

                        <div className={styles.drawerContent}>
                            {creationStatus === 'NOT_UPDATING' ? (
                                isAlreadyRegistered ? (
                                    <div className={styles.registeredCard}>
                                        <div className={styles.registeredHeader}>
                                            <span className={styles.registeredBadge}>Existing Profile</span>
                                            <div className={styles.registeredName}>
                                                {clientToAssign?.client_name}
                                            </div>
                                        </div>
                                        <div className={styles.registeredMeta}>
                                            {clientToAssign?.client_address && (
                                                <span>
                                                    <FiMapPin size={12} /> {clientToAssign?.client_address}
                                                </span>
                                            )}
                                            <span className={styles.registeredPhone}>
                                                <FiPhone size={12} />
                                                <span>{clientToAssign?.countryCode}</span>
                                                <span>{clientToAssign?.mobile}</span>
                                            </span>
                                        </div>
                                        <div className={styles.familySummary}>
                                            <FiUsers size={12} />{' '}
                                            {Array.isArray(clientToAssign?.relatives && JSON.parse(clientToAssign?.relatives))
                                                ? JSON.parse(clientToAssign?.relatives)?.length
                                                : 0} family members linked
                                        </div>
                                        <div className={styles.relativesWrapper}>
                                            {(clientToAssign?.relatives && (() => {
                                                try {
                                                    const parsedRelatives = JSON.parse(clientToAssign.relatives);
                                                    return Array.isArray(parsedRelatives) ? parsedRelatives : [];
                                                } catch (error) {
                                                    console.error('Error parsing relatives:', error);
                                                    return [];
                                                }
                                            })())?.map((itemRelative, index) => (
                                                <div key={index} className={styles.eachRelative}>
                                                    <div className={styles.erUpper}>
                                                        <div className={styles.rFullName}>
                                                            {itemRelative?.salutation}{' '}
                                                            {`${itemRelative?.firstName} ${itemRelative?.middleName} ${itemRelative?.lastName}`.trim()}
                                                        </div>
                                                        <div className={styles.rAge}>
                                                            {getAge(itemRelative?.dateOfBirth)} years
                                                        </div>
                                                    </div>
                                                    <div className={styles.erLower}>
                                                        <div>{itemRelative?.gender}</div>
                                                        <div className={styles.rtfh}>{itemRelative?.relationToFamilyHead}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className={styles.alreadyRegisteredLink}>
                                            <Link to={`/user/${clientToAssign?.clientStoreRelationIdentifier}`}>
                                                Add a relative to this family
                                            </Link>
                                        </div>
                                    </div>
                                ) : (
                                    <div className={styles.formGrid}>
                                        <div className={`${styles.field} ${styles.fieldFull}`}>
                                            <label className={styles.fieldLabel}>
                                                <FiPhone size={14} /> Phone Number
                                            </label>
                                            <OtpInput
                                                value={phoneNumber.otp}
                                                focusInput={0}
                                                numInputs={10}
                                                shouldAutoFocus
                                                onChange={(otp) => phoneNumberHandler(otp)}
                                                isInputNum
                                                containerStyle={styles.phoneNumberContainer}
                                                inputStyle={styles.phoneInputBox}
                                                focusStyle={styles.otpFocus}
                                            />
                                            <p className={styles.fieldInfo}>We’ll send alerts to this number.</p>
                                        </div>

                                        <div className={styles.identityRow}>
                                            <div className={`${styles.field} ${styles.fieldSnug}`}>
                                                <label className={styles.fieldLabel}>
                                                    <FiUser size={14} /> Title
                                                </label>
                                                {isMobileViewport ? (
                                                    <Select
                                                        classNamePrefix="addClientSelect"
                                                        options={TITLE_OPTIONS}
                                                        value={TITLE_OPTIONS.find((o) => o.value === title) || null}
                                                        onChange={(selected) => setTitle(selected ? selected.value : '')}
                                                        placeholder="Title"
                                                        isSearchable={false}
                                                        isClearable
                                                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                                        styles={mobileSelectStyles}
                                                    />
                                                ) : (
                                                    <select
                                                        className={styles.selectControl}
                                                        onChange={(e) => setTitle(e.target.value)}
                                                        value={title}
                                                    >
                                                        <option value="">Title</option>
                                                        <option value="Mr.">Mr.</option>
                                                        <option value="Ms.">Ms.</option>
                                                        <option value="Mrs.">Mrs.</option>
                                                        <option value="Dr.">Dr.</option>
                                                        <option value="Baby">Baby</option>
                                                        <option value="Kumari">Kumari</option>
                                                    </select>
                                                )}
                                            </div>

                                            <div className={styles.field}>
                                                <label className={styles.fieldLabel}>
                                                    <FiUser size={14} /> Full Name
                                                </label>
                                                <input
                                                    className={styles.inputControl}
                                                    onChange={(e) => setFullName(e.target.value)}
                                                    value={fullName}
                                                    placeholder="e.g. Aishwarya Singh"
                                                />
                                            </div>
                                        </div>

                                        <div className={`${styles.field} ${styles.fieldFull}`}>
                                            <label className={styles.fieldLabel}>
                                                <FiMail size={14} /> Email
                                            </label>
                                            <input
                                                className={styles.inputControl}
                                                placeholder="Client email ID"
                                                onChange={(e) => setEmail(e.target.value)}
                                                value={email}
                                            />
                                        </div>

                                        <div className={`${styles.field} ${styles.fieldFull}`}>
                                            <label className={styles.fieldLabel}>
                                                <FiUser size={14} /> Gender
                                            </label>
                                            <div className={styles.genderRow}>
                                                {GENDER_OPTIONS.map(({ value, symbol, Icon }) => (
                                                    <button
                                                        key={value}
                                                        type="button"
                                                        onClick={() => setGender(value)}
                                                        className={gender === value ? `${styles.genderButton} ${styles.genderButtonActive}` : styles.genderButton}
                                                    >
                                                        {Icon
                                                            ? <Icon size={16} className={styles.genderIcon} />
                                                            : <span className={styles.genderSymbol}>{symbol}</span>}
                                                        <span className={styles.genderLabel}>{value}</span>
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        <div className={`${styles.field} ${styles.fieldFull}`}>
                                            <label className={styles.fieldLabel}>
                                                <FiMapPin size={14} /> Address
                                            </label>
                                            <textarea
                                                className={styles.textAreaControl}
                                                rows={3}
                                                onChange={(e) => setAddress(e.target.value)}
                                                value={address}
                                                placeholder="House, street, locality"
                                            />
                                        </div>

                                        <div className={styles.ageFields}>
                                            <div className={styles.field}>
                                                <label className={styles.fieldLabel}>
                                                    <FiCalendar size={14} /> Age (Years)
                                                </label>
                                                {isMobileViewport ? (
                                                    <Select
                                                        classNamePrefix="addClientSelect"
                                                        options={yearOptions}
                                                        value={yearOptions.find((o) => o.value === ageYear) || null}
                                                        onChange={(selected) => setAgeYear(selected ? selected.value : '')}
                                                        placeholder="Select"
                                                        isClearable
                                                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                                        styles={mobileSelectStyles}
                                                    />
                                                ) : (
                                                    <select
                                                        className={styles.selectControl}
                                                        onChange={(e) => setAgeYear(e.target.value)}
                                                        value={ageYear}
                                                    >
                                                        <option value="">Select</option>
                                                        {years?.map((item, index) => (
                                                            <option key={index} value={item}>{item}</option>
                                                        ))}
                                                    </select>
                                                )}
                                            </div>

                                            <div className={styles.field}>
                                                <label className={styles.fieldLabel}>
                                                    <FiCalendar size={14} /> Date of Birth
                                                </label>
                                                <input
                                                    type="date"
                                                    className={styles.dateControl}
                                                    value={dob}
                                                    onChange={(e) => setDob(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )
                            ) : (
                                <div className={styles.loaderState}>
                                    <FiLoader size={26} className={styles.loaderIcon} />
                                    <span>Adding client — hold on a second.</span>
                                </div>
                            )}
                        </div>

                        <div className={styles.drawerFooter}>
                            <span className={styles.footerHint}>
                                <FiInfo size={12} /> {minimumRequirementsCopy}
                            </span>
                            <div className={styles.footerActions}>
                                <button type="button" className={styles.secondaryButton} onClick={closeModal}>
                                    Cancel
                                </button>
                                {isAlreadyRegistered ? (
                                    <button
                                        type="button"
                                        className={styles.primaryButton}
                                        onClick={() => assignClientHandler(clientToAssign)}
                                        disabled={creationStatus !== 'NOT_UPDATING'}
                                    >
                                        Assign Client
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        className={styles.primaryButton}
                                        onClick={addNewClientHandler}
                                        disabled={!isReadyToSubmit || creationStatus !== 'NOT_UPDATING'}
                                    >
                                        Add Client
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return null
}

export default AddNewClient